import React, { ReactNode } from 'react';
import { Site } from '@99designs/site-navigation/lib/Site';
import { config } from '../branding-design/config';
import { Onboarder } from '../components/Onboarder';
import type { Role } from '@99designs/site-navigation/consts';

interface Props {
    role: Role;
    site: Site;
    exchangeRate: number;
    onPageChange: (title: string, description: string) => void;
    Layout: React.ComponentType<{ site: Site; role: Role; children: ReactNode }>;
}

export function GuidedBrandingProductRecommender({
    role,
    site,
    exchangeRate,
    onPageChange,
    Layout,
}: Props) {
    return (
        <Onboarder
            config={config(role, site, exchangeRate, Layout)}
            role={role}
            onPageChange={onPageChange}
        />
    );
}
